// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"602390f0","453":"d498b7af","455":"e0b7f9d8"}[chunkId] + ".chunk.js";
};